import * as types from '../actionTypes/ActionTypes';

export const getDataFilterInternalSuccess = (payload) => ({
  type: types.VOUCHER_PAYMENT_INTERNAL_FILTER.INTERNAL_FILTER_GET_REQUEST_SUCCESS,
  payload,
});
